<template>
  <div class="bussiness">
    <ComponentHeader v-bind:index="index" />
    <div id="image" class="image">
      <div>BUSSINESS</div>
      <div>业务</div>
    </div>

    <section>
      <el-row class="block subyw" :gutter="10">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="subyw_bt"
          >主营业务</el-col
        >
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="main">
            <div>
              <img src="../assets/image/main_pic1.jpg" alt="" />
              <div>医用织物洗涤</div>
            </div>
            <div>
              <img src="../assets/image/main_pic2.jpg" alt="" />
              <div>工服洗涤</div>
            </div>
          </el-col>
        </el-row>

        <div class="line"></div>

        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="block_tzbt"
          >拓展业务</el-col
        >
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="main">
            <div>
              <img src="../assets/image/tz_yw01.png" alt="" />
              <div>酒店布草洗涤</div>
              <div></div>
            </div>
            <div>
              <img src="../assets/image/tz_yw02.png" alt="" />
              <div>干洗</div>
            </div>
          </el-col>
        </el-row>
        <div :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="seeMore">
          <button @click="back">返回</button>
        </div>
      </el-row>
    </section>
    <ComponentFooter />
  </div>
</template>


<script>
import "../ui/ui.js";
import ComponentFooter from "../components/Footer.vue";
import ComponentHeader from "../components/Header.vue";

export default {
  name: "Home",
  components: { ComponentFooter, ComponentHeader },
  data() {
    return {
      index: "4",
      news: [
        { title: "新闻一", id: 0 },
        { title: "新闻二", id: 1 },
        { title: "新闻三", id: 2 },
        { title: "新闻四", id: 3 },
        { title: "新闻五", id: 4 },
      ],
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
    goNew(i) {
      this.$router.push(`/new/id=${i}`);
    },
  },
};
</script>

<style lang="less" scoped>
.bussiness {
  .el-row {
    margin: 0 !important;
  }
  .image {
    width: 100%;
    background: url("../assets/image/1-01-01.png") no-repeat;
    background-size: 100% 100%;
    height: 3.2rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    div {
      color: #d2f9e9;
      font-weight: 400;
      &:first-child {
        font-size: 0.18rem;
      }
      &:last-child {
        font-size: 0.15rem;
      }
    }
  }
  section {
    .subyw_bt {
      margin: 22px 0 20px 0;
      font-size: 0.16rem;
      text-align: center;
      font-weight: bold;
      color: rgba(31, 148, 141, 1);
    }
    .block_tzbt {
      margin: 0 0 20px 0;
      font-size: 0.16rem;
      text-align: center;
      font-weight: bold;
      color: rgba(31, 148, 141, 1);
    }
    .line {
      height: 1px;
      width: 80%;
      border-bottom: 1px dashed #707070;
      margin: 0.22rem auto;
    }
    .main {
      width: 100%;
      display: flex;
      justify-content: center;
      text-align: center;
      font-size: 0.1rem;
      div {
        width: 25%;
        &:first-child {
          margin: 0 0.5rem 0 0;
        }
        &:last-child {
          margin: 0 0px 0 0.5rem;
        }
        img {
          width: 100%;
          margin-bottom: 10px;
        }
        div {
          width: 100%;
          text-align: center;
          margin: 0 !important;
          margin-top: 15px;
        }
      }
    }
    .seeMore {
      font-size: 0.7rem;
      display: flex;
      justify-content: center;
      margin: 25px 0 22px 0;
      button {
        width: 84px;
        height: 33px;
        color: #000;
        background: #e6fffb;
        border-radius: 30px;
        outline: 0;
        border: 0;
      }
    }
  }
}
</style>